export default "__VITE_ASSET__CZ$GVBSJ__"